import gql from "graphql-tag";
import actionFormContainer from "./actionFormContainer";
import {cancelCancelClientDispatch, successCancelClientDispatch} from "../../../actions/ClientDispatchApiActions";

export default actionFormContainer({
  mutation: gql`
    mutation cancelClientDispatch($data: CancelClientDispatchInput!) {
      cancelClientDispatch(input: $data) {
        errors { key message }
      }
    }
  `,
  resultField: "cancelClientDispatch",
  buildData: (props, values) => ({clientDispatchId: props.clientDispatchId, reason: values.get("reason")}),
  formProps: () => ({
    withReason: true,
    submitLabel: "Cancel Dispatch",
    message: "Cancel this draft? Its containers are freed for other transfers and dispatches.",
  }),
  success: successCancelClientDispatch,
  cancel: cancelCancelClientDispatch,
});
